/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Rolessummary2Inputs */

const en_usermanagement_help_rolessummary2 = /** @type {(inputs: Usermanagement_Help_Rolessummary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Below is a written summary of each role and its permissions for both the Offering and Investment phases.`)
};

/**
* | output |
* | --- |
* | "Below is a written summary of each role and its permissions for both the Offering and Investment phases." |
*
* @param {Usermanagement_Help_Rolessummary2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_rolessummary2 = /** @type {((inputs?: Usermanagement_Help_Rolessummary2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Rolessummary2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_rolessummary2(inputs)
});
export { usermanagement_help_rolessummary2 as "userManagement_help_rolesSummary" }